module.exports = __webpack_public_path__ + "static/media/Slide50.6b3d56b4.JPG";